<template>
  <b-modal ref="channelModal" id="modal1" hide-footer no-close-on-backdrop no-close-on-esc class="channel-modal" title="channel modal" @show="beforeShown" @shown="afterShown">
  	<div class="channel-section channel-modal-popup">

      	<div class="header">
  			<div class="left-heading">
  				<span class="icon-channel"></span>
  				<span class="title">{{ channelName }}</span>
  			</div>

  			<div id="searchFilterContainer" class="search-filter-container"></div>
  			<b-popover target="searchFilterPopover"
          triggers="click"
          container="searchFilterContainer">
          <template slot="title">
  					<div class="icon-filter"></div>
  					<div class="heading">Narrow Your Results</div>
  			   </template>
           <div class="search-row">
  				     <input type="text" placeholder="type to search result" aria-label="search result" class="input-search">
  				     <div class="search-btn">
  					   <span class="fas fa-search"></span>
  				</div>
  			   </div>
  			   <div class="facet-header">
  					<div class="field-container">
  						<input type="checkbox" aria-label="select job">
  					</div>
  					<div class="title">
  						Job Id
  					</div>
  					<div class="icon_container">
  					  <b-btn v-b-toggle.jobId>
  						<span class="collapsed icon-collapse" aria-label="collapse">
                <span class="visibility_hide">collapse</span>
              </span>
  						<span class="expand icon-expand" aria-label="expand">
                <span class="visibility_hide">expand</span>
              </span>
  					  </b-btn>
  					</div>
  			   </div>
  			   <b-collapse visible id="jobId">
  				    <div class="facet-content-section">
  						<div class="content-row">
  							<div class="field-container">
  								<input type="checkbox" aria-label="select job">
  							</div>
  							<div class="title">
  								Job1000
  							</div>
  						</div>
  						<div class="content-row">
  							<div class="field-container">
  								<input type="checkbox" aria-label="select job">
  							</div>
  							<div class="title">
  								Job1010
  							</div>
  						</div>
  						<div class="content-row">
  							<div class="field-container">
  								<input type="checkbox" aria-label="select job">
  							</div>
  							<div class="title">
  								Job1111
  							</div>
  						</div>
  				   </div>
  				</b-collapse>
  			</b-popover>
  		</div>
  		<div class="channel-content-section">
  			<div class="left-channel-panel" style="height: 100%;">
  				<!--
  				<div class="head">Channels</div>
  				-->
          <vue-bootstrap-typeahead
            ref="channelAutoComplete" v-model="channelQuery" placeholder="Search for a Channel" :serializer="c => c.channelName" :data="myChannels" @hit="channelSearched = $event"
          />
  				<div class="content-section channel-list">
  					<div :id="channel.externalId" class="content-row" :class="channelClass(channel)" v-for="channel in unReadChannels" v-if="unReadChannels.length > 0" @click="updateChannel(channel, true)" :key="channel.externalId">
  						<template v-if="channel.isUnread">
                <div class="channel_sec">
    							<div class="ic_new_msg"></div>
    					    <div class="ic ic9-channel2">
    					      <div class="count_new_msg">
    									<channel-unread-counter :externalId="channel.externalId"></channel-unread-counter>
    								</div>
    					    </div>
    						</div>
    						<div class="title">{{channel.channelName}}</div>
              </template>
              <template v-else>
                <div class="icon-channel icon"></div>
                <div class="title">{{channel.channelName}}</div>
                <channel-unread-counter :externalId="channel.externalId"></channel-unread-counter>
              </template>
  					</div>
            <div :id="channel.externalId" class="content-row" :class="channelClass(channel)" v-for="channel in readChannels" v-if="readChannels.length > 0" @click="updateChannel(channel)" :key="channel.externalId">
  						<div class="icon-channel icon"></div>
  						<div class="title">{{channel.channelName}}</div>
  						<channel-unread-counter :externalId="channel.externalId"></channel-unread-counter>
  					</div>
  				</div>
  			</div>
  			<div class="channel-mid-column" :class="[canSendOtherTypes ? 'channel-width' : '']">
  				<div class="msg_row_section">
  					<div class="msg_section_inner mb-3">
  						<div class="chat-message" style="margin-bottom: 20px;" v-for="(message, index) in messages" v-if="messages.length > 0">
  							<div class="message-avatar-default">
  								<span class="icon-user"></span>
                  <!--
                  <pre>{{ message }}</pre>
                  -->
  							</div>
  							<div class="message-details">
  								<div class="message-author-name">
  									<span class="message-author">{{message.name}}</span>
  									<span class="message-time" v-if="showMessageTimestamp"> {{message.date}}</span>
  									<span class="job-tag tag_notification" v-if="showUrgentNotificationsTag && message.type && message.type === 'Urgent Notification'"> {{message.type}}</span>
  									<span class="job-tag tag_recommendation" v-if="message.type && message.type === 'Recommendation'"> {{message.type}}</span>

                    <template v-if="message.uuid === userId && canShowModify && canSend">
                      <b-nav-item-dropdown right class="more_option">
                          <!-- Using button-content slot -->
                          <template slot="button-content">
                            <span class="ic9-iconMore-0005">
                              <span class="visibility_hide">more message options</span>
                            </span>
                          </template>
                          <template v-if="!message.isFile">
                            <b-dropdown-item @click="openEditMessage(message, index)">
                              <!--
                              <span class="icon-edit"></span>
                              -->
                              <span class="txt">edit</span>
                            </b-dropdown-item>
                          </template>
                          <b-dropdown-item class="last_child" @click="deleteMessage(message)">
                            <!--
                            <span class="icon-bin"></span>
                            -->
                            <span class="txt">delete</span>
                          </b-dropdown-item>
                      </b-nav-item-dropdown>
                    </template>
                  </div>
  								<div class="message">
  									<template v-if="!isEditMessageClicked">
                      <template v-if="message.isFile">
                        <div class="message-content">
                          <a :href="message.text" target="_blank" style="color: #0645AD;">{{message.fileName}}</a>
                        </div>
                      </template>
                      <template v-else>
                        <div class="message-content" v-html="message.text" @click="handlerShowImageInModal"></div>
                      </template>
                    </template>
  								  <div class="message-edit" :id="message['.key']" style="display: none;">
  									  <editor api-key="no-api-key"
                        v-model="editMessage"
                        :init="{
                          base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                          menubar: false,
                          plugins: plugins,
                          toolbar: toolbar,
                          branding: false,
                          statusbar: false
                        }"
                        :id="'richTextEditMessage-' + index"
                        aria-label="add text message"
                        @onInit="(event, editor) => {handlerInitEditMessage(event, editor, index)}"
                        @onKeyUp="(event, editor) => {handlerKeyUpEditMessage(event, editor, message)}">
                      </editor>
  									  <div class="btn-container">
  										  <button type="submit" value="save" class="send-btn btn" @click="saveEditMessage(true, message)">save</button>
  										  <button type="submit" value="cancel" class="send-btn btn" @click="cancelEditMessage(message)">cancel</button>
                      </div>
  								  </div>
  								</div>
  							</div>
  						</div>
  					</div>
  				</div>
  				<div class="chat-message-form rich-text-editor-box" v-if="canSend">
  					<div class="channel-dropdown">
  					  <b-dropdown no-caret v-if="canSendOtherTypes">
  						<template slot="button-content">
  						  <span class="icon icon-channel" v-if="messageType == 'Message'">
                  <span class="visibility_hide">channel</span>
                </span>
                <span class="icon icon-bell" v-if="messageType == 'Urgent Notification'"></span>
                <span class="icon icon-bullhorn" v-if="messageType == 'Recommendation'"></span>
  						  <span class="icon-dropdown2"></span>
  						</template>
  						<b-dropdown-item @click="changeType('Recommendation')" :disabled="messageType === 'Recommendation'"><span class="icon icon-bullhorn"></span><span class="text">Recommendation</span></b-dropdown-item>
  						<b-dropdown-item @click="changeType('Urgent Notification')" :disabled="messageType === 'Urgent Notification'"><span class="icon icon-bell"></span><span class="text">Urgent Notification</span></b-dropdown-item>
  						<b-dropdown-item @click="changeType('Message')" :disabled="messageType === 'Message'"><span class="icon icon-channel"></span><span class="text">Message</span></b-dropdown-item>
  					  </b-dropdown>
  					</div>
  					<div class="field-section">
  						<editor api-key="no-api-key"
                v-model="sendMessage"
                :init="{
                  base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                  menubar: false,
                  plugins: plugins,
                  toolbar: toolbar,
                  branding: false,
                  statusbar: false,
                  end_container_on_empty_block: true
                }"
                id="richTextMessage"
                aria-label="add text message"
                @onInit="handlerInit"
                @onKeyUp="handlerKeyUp">
              </editor>
  						<div class="right-section rich-text-editor-btn">
                <input type="file" id="fileUpload" ref="fileInput" class="file-attachment" @change="handlerFileUpload" />
                <label for="fileUpload" id="fileUploadIcon" aria-label="upload file">
                  <template v-if="isUploadingAttachment">
                    <span class="fa fa-spinner fa-pulse"></span>
                  </template>
                  <template v-else>
                    <span class="fa fa-paperclip attachment-icon mr-1" aria-hidden="true"></span>
                  </template>
                </label>
  							<button type="submit" value="send" class="send-btn btn rich-text-editor-send-btn" id="sendMessageButton" @click="send(true)">
                  <span class="ic9-send ic9-iconSend-0001">
                    <span class="visibility_hide">send</span>
                  </span>
                </button>
  						</div>
  					</div>
  				</div>
  			</div>

  			<!--
  			<div class="right-member-panel">
  				<div class="head">Members
  					<button class="btn_close">
              <span class="ic-close"></span>
            </button>
  				</div>

  				<div class="content-section">
  					<div class="content-row">
  						<div class="user-column">
  							<div class="icon-user"></div>
  							<div class="status-sign"></div>
  						</div>
  						<div class="name">Prof. Picasso</div>
  					</div>
  					<div class="content-row">
  						<div class="user-column">
  							<div class="icon-user"></div>
  							<div class="status-sign"></div>
  						</div>
  						<div class="name">Umberto Eco’s Stream</div>
  					</div>
  					<div class="content-row">
  						<div class="user-column">
  							<div class="icon-user"></div>
  							<div class="status-sign"></div>
  						</div>
  						<div class="name">Super Admin</div>
  					</div>
  					<div class="content-row">
  						<div class="user-column">
  							<div class="icon-user"></div>
  							<div class="status-sign"></div>
  						</div>
  						<div class="name">Prof. Goya</div>
  					</div>

  					<div class="content-row">
  						<div class="user-column">
  							<div class="icon-user"></div>
  							<div class="status-sign"></div>
  						</div>
  						<div class="name">Prof. Whiteman</div>
  					</div>

  				</div>
  			</div>
  			-->

  		</div>

      <!-- image viewer modal -->
      <div>
        <b-modal ref="imageViewerModal" @hidden="selectedImageSource = null" hide-header hide-footer size="xl">
          <img :src="selectedImageSource" class="w-100" alt="Selected Image" />
        </b-modal>
      </div>

      <bad-words-prompt ref="badWordsPopup" @sendMaskedBadWords="sendMaskedBadWords" :editorInstanceId="editorInstanceId"></bad-words-prompt>

  	</div>
  </b-modal>
</template>

<script>
import '../../../assets/module/sass/channel/channel.scss'
import { mapState, mapActions } from 'vuex'
import { db, storage } from '../../../firebase'
import { PACKAGE } from '../../../package_constants'
import { StorageFactory } from '../../../storageFactory'
import ChannelUnreadCounter from './ChannelUnreadCounter'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Editor from '@tinymce/tinymce-vue'
import BadWordsPrompt from './BadWordsPrompt'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'channel',
  props: ['externalId', 'channelData'],
  components: {
    Editor,
    ChannelUnreadCounter,
    VueBootstrapTypeahead,
    BadWordsPrompt
  },
  data: (vm) => {
    return {
      sendMessage: '',
      editMessage: '',
      messageType: 'Message',
      userRole: localStore.getItem('userrole'),
      userId: localStore.getItem('userid'),
      userName: localStore.getItem('userFullName'),
      messages: [],
      currentChannel: vm.externalId,
      currentChannelData: vm.channelData,
      channelName: '',
      canShowModify: true,
      channelSearched: {},
      channelQuery: '',
      isScrollSelectedChannelToTop: false,
      readChannels: [],
      unReadChannels: [],
      plugins: 'lists  autolink charmap code hr link textcolor',
      toolbar: 'bold italic strikethrough | bullist numlist | indent outdent | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink',
      isUploadingAttachment: false,
      isEditMessageClicked: false,
      selectedImageSource: null,
      selectedMessage: '',
      editorInstanceId: ''
    }
  },
  watch: {
    externalId (newExternalId) {
      this.currentChannel = newExternalId
    },
    messages () {
      setTimeout(() => {
        var msgSectionHeight = $('.msg_section_inner').innerHeight()
        $('.msg_row_section').scrollTop(msgSectionHeight)
      }, 100)
    },
    selectedChannel (newSelectedChannel) {
      if (newSelectedChannel) {
        let newSelectedChannelInfo = {}
        for (var i = 0; i < this.myChannels.length; i++) {
          if (this.myChannels[i].externalId === newSelectedChannel) {
            newSelectedChannelInfo = this.myChannels[i]
            break
          }
        }
        this.updateChannel(newSelectedChannelInfo)
      }
    },
    channelSearched (newChannelSearched) {
      if (Object.keys(newChannelSearched).length !== 0) {
        this.scrollSelectedChannelToTop(newChannelSearched)
        this.updateChannel(newChannelSearched)
      }
    }
  },
  mounted () {
    this.$root.$on('isScrollSelectedChannelToTop', (isScrollToTop, externalId) => {
      this.currentChannel = externalId
      this.isScrollSelectedChannelToTop = isScrollToTop
    })
    this.loadChannelSetup()
    if (!this.isScrollSelectedChannelToTop) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.populateReadUnreadChannels(this.myChannels, false)
        })
      })
    }
  },
  async created () {
    this.currentChannel = this.externalId
    this.currentChannelData = this.channelData
    this.$watch('currentChannel', (externalId) => {
      if (externalId) {
        this.$bindAsArray('messages', db.ref('channels/' + externalId + '/Messages'))
      }
    }, {
      immediate: true
    })
  },
  firebase: {
    messages: {
      source: db.ref('channels/' + this.currentChannel + '/Messages'),
      readyCallback: function () {
        this.loadIsChannelReady(true)
      },
      cancelCallback: function (e) {
        console.log('Could not get messages', e)
      }
    }
  },
  methods: {
    ...mapActions([
      'loadUserJwt',
      'loadIsChannelReady',
      'loadIsChannelWindowClosed',
      'updateUnread',
      'loadAttachmentUpload'
    ]),
    preventEnterKeyEvent (container, ed) {
      $(container).keydown((e) => {
        const keyPressed = e.keyCode || e.which
        if ((keyPressed === 13) && !(e.ctrlKey || e.metaKey)) {
          let content = ed.getContent().replace(/<p>&nbsp;<\/p>/g, '')
          ed.setContent(content)
          ed.selection.select(ed.getBody(), true)
          ed.selection.collapse(false)
          return false
        }
      })
    },
    handlerInit (ev, editor) {
      $('#richTextMessage_ifr').width('88%')
      $('#richTextMessage_ifr').height('46px')
      $('.field-section').css('visibility', 'visible')
      let container = $('#richTextMessage_ifr')[0].contentWindow.document.body
      this.preventEnterKeyEvent(container, editor)
    },
    handlerKeyUp (ev, editor) {
      const keyPressed = ev.keyCode || ev.which
      if (((keyPressed === 13) && !(ev.ctrlKey || ev.metaKey)) || ((keyPressed === 17) && (ev.target.innerHTML.indexOf('<img') !== -1))) {
        let isBadWordsNotAllowed = (keyPressed === 13) || (ev.target.innerHTML.indexOf('<img') === -1)
        this.send(isBadWordsNotAllowed)
      }
    },
    handlerInitEditMessage (ev, editor, index) {
      let elemId = '#richTextEditMessage-' + index + '_ifr'
      $(elemId).height('46px')
      let container = $(elemId)[0].contentWindow.document.body
      this.preventEnterKeyEvent(container, editor)
    },
    handlerKeyUpEditMessage (ev, editor, message) {
      if ((ev.keyCode === 13) && !(ev.ctrlKey || ev.metaKey)) {
        this.saveEditMessage(true, message)
      }
    },
    handlerShowImageInModal (ev) {
      this.selectedImageSource = null
      if (ev.target.matches('.open-img-modal')) {
        this.selectedImageSource = ev.target.currentSrc
        this.$refs['imageViewerModal'].doShow()
      }
    },
    closeImageViewerModal () {
      this.$refs['imageViewerModal'].hide()
    },
    handlerFileUpload (ev) {
      let files = ev.target.files || ev.dataTransfer.files
      if (!files.length) {
        return
      }
      this.isUploadingAttachment = true
      let fileToBeUpload = files[0]
      $('#messageInputBox').prop('disabled', true)
      $('#sendMessageButton').prop('disabled', true)
      let storageRef = storage.ref('files/' + this.userId)
      let spaceRef = storageRef.child(fileToBeUpload.name)
      spaceRef.put(fileToBeUpload).then((snapshot) => {
        snapshot.ref.getDownloadURL().then((downloadURL) => {
          let data = {
            'longDynamicLink': 'https://pragyasystems.page.link/?link=' + encodeURI(downloadURL),
            'suffix': {
              'option': 'UNGUESSABLE'
            }
          }
          this.loadAttachmentUpload(data).then(result => {
            let uploadedFileLink = result.shortLink
            this.sendUploadedFile(fileToBeUpload.name, uploadedFileLink)
            $('#messageInputBox').prop('disabled', false)
            $('#sendMessageButton').prop('disabled', false)
            this.clearFilePath()
          })
        })
      })
    },
    clearFilePath () {
      const input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
      this.isUploadingAttachment = false
    },
    beforeShown () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.populateReadUnreadChannels(this.myChannels, false)
        })
      })
    },
    populateReadUnreadChannels (channels, autoScroll) {
      this.readChannels = []
      this.unReadChannels = []
      let clickedChannel = {}
      channels.forEach(channel => {
        let count = this.channelUnreadCount[channel.externalId]
        if (count === 0) {
          this.readChannels.push(channel)
        } else {
          channel.isUnread = true
          this.unReadChannels.push(channel)
        }
        // getting selected channel
        if (this.currentChannel === channel.externalId) {
          clickedChannel = channel
        }
      })
      if (autoScroll && this.isScrollSelectedChannelToTop) {
        this.scrollSelectedChannelToTop(clickedChannel)
      }
    },
    afterShown () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.populateReadUnreadChannels(this.myChannels, true)
          }, 500)
        })
      })
    },
    scrollSelectedChannelToTop (channel) {
      if (channel) {
        let container = $('.channel-list')
        let scrollTo = $('#' + channel.externalId)
        container.scrollTop(
          scrollTo.offset().top - container.offset().top + container.scrollTop()
        )
      }
      this.isScrollSelectedChannelToTop = false
    },
    async updateChannel (channel, isUpdateUnreadCount) {
      this.channelSearched = {}
      this.channelQuery = ''
      this.$refs.channelAutoComplete.inputValue = ''
      if (this.currentChannel !== channel.externalId) {
        await db.ref('channels/' + channel.externalId + '/unread/' + this.userId).remove()
        this.messages = []
        channel.isUnread = false
        this.currentChannel = channel.externalId
        this.externalId = channel.externalId
        this.currentChannelData = channel
        if (isUpdateUnreadCount) {
          this.updateUnread({channelId: channel.externalId, unread: 0})
        }
      }
    },
    channelClass (channel) {
      if (channel.externalId === this.currentChannel) {
        this.channelName = channel.channelName
        return 'active'
      }
      return ''
    },
    loadChannelSetup () {
      console.log('Channel loaded')
    },
    isUnreadChannel (channel) {
      if (this.channelUnreadCount[channel.externalId] &&  this.channelUnreadCount[channel.externalId] > 0) {
        return true
      }
      return false
    },
    markAsRead () {
      console.log('marking unread for: ', this.currentChannel)
      db.ref('channels/' + this.currentChannel + '/unread/' + this.userId).remove()
    },
    openEditMessage (message, index) {
      this.editMessage = message.text
      this.canShowModify = false
      let key = message['.key']
      $('#' + key).show()
      this.selectedMessage = message
      this.isEditMessageClicked = true
      this.editorInstanceId = 'richTextEditMessage-' + index + '_ifr'
    },
    saveEditMessage (isBadWordsNotAllowed, message) {
      let isNotAllowed = this.$refs.badWordsPopup.showPrompt(this.editMessage, isBadWordsNotAllowed)
      if (!isNotAllowed) {
        this.canShowModify = true
        let key = message['.key']
        $('#' + key).hide()
        this.editMessage = this.editMessage.replaceAll(/<p style=.*>&nbsp;<\/p>/g, '').replaceAll(/<p>&nbsp;<\/p>/g, '')
        this.editMessage = this.editMessage.replaceAll('<a', '<a style="color: #0645AD;" target="_blank" rel="noopener"')
        this.editMessage = this.editMessage.replace('<img', '<img style="width: 350px; height: 200px; cursor: zoom-in;" class="open-img-modal"')
        this.editMessage = this.$refs.badWordsPopup.maskBadWords(this.editMessage)
        this.$firebaseRefs.messages.child(message['.key']).update({ text: this.editMessage })
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Successfully saved the message!'
        })
        // after saving
        this.editMessage = ''
        this.selectedMessage = ''
        this.editorInstanceId = ''
        this.isEditMessageClicked = false
      }
    },
    cancelEditMessage (message) {
      this.canShowModify = true
      let key = message['.key']
      $('#' + key).hide()
      this.editMessage = ''
      this.selectedMessage = ''
      this.editorInstanceId = ''
      this.isEditMessageClicked = false
    },
    deleteMessage (message) {
      if (message.uuid === this.userId) {
        if (message.isFile) {
          let storageRef = storage.ref('files/' + this.userId)
          let spaceRef = storageRef.child(message.fileName)
          spaceRef.delete().then(() => {
            console.log('file deleted from storage')
          }).catch((error) => {
            console.log('unable to delete file from storage')
          })
        }
        this.$firebaseRefs.messages.child(message['.key']).remove()
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Successfully deleted the message!'
        })
      } else {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'You do not have the permission to delete this message'
        })
      }
    },
    sendMaskedBadWords () {
      if (this.isEditMessageClicked) {
        this.saveEditMessage(false, this.selectedMessage)
      } else {
        this.send(false)
      }
    },
    send (isBadWordsNotAllowed) {
      if (this.sendMessage.length > 0) {
        this.editorInstanceId = 'richTextMessage_ifr'
        let isNotAllowed = this.$refs.badWordsPopup.showPrompt(this.sendMessage, isBadWordsNotAllowed)
        if (!isNotAllowed) {
          this.sendMessage = this.sendMessage.replaceAll('<a', '<a style="color: #0645AD;" target="_blank" rel="noopener"')
          this.sendMessage = this.sendMessage.replace('<img', '<img style="width: 350px; height: 200px; cursor: zoom-in;" class="open-img-modal"')
          this.sendMessage = this.$refs.badWordsPopup.maskBadWords(this.sendMessage)
          let date = new Date()
          let dd = date.getDate()
          let mm = date.getMonth() + 1
          let yyyy = date.getFullYear()
          let hr = date.getHours()
          let mn = date.getMinutes()
          if (mn < 10) {
            mn = '0' + mn
          }
          const message = {
            name: this.userName,
            uuid: this.userId,
            text: this.sendMessage,
            date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
            type: this.messageType
          }
          this.$firebaseRefs.messages.push(message)
          this.updateAllUnread()
          this.sendMessage = ''
          this.editorInstanceId = ''
          setTimeout(() => {
            var msgSectionHeight = $('.msg_section_inner').innerHeight()
            $('.msg_row_section').scrollTop(msgSectionHeight)
          }, 100)
        }
      }
    },
    sendUploadedFile (fileName, uploadedFileLink) {
      if (uploadedFileLink.length > 0) {
        let date = new Date()
        let dd = date.getDate()
        let mm = date.getMonth() + 1
        let yyyy = date.getFullYear()
        let hr = date.getHours()
        let mn = date.getMinutes()
        if (mn < 10) {
          mn = '0' + mn
        }
        const message = {
          name: this.userName,
          uuid: this.userId,
          text: uploadedFileLink,
          date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
          type: this.messageType,
          isFile: true,
          fileName: fileName
        }
        this.$firebaseRefs.messages.push(message)
        this.updateAllUnread()
        this.sendMessage = ''

        setTimeout(() => {
          var msgSectionHeight = $('.msg_section_inner').innerHeight()
          $('.msg_row_section').scrollTop(msgSectionHeight)
        }, 100)
      }
    },
    updateAllUnread () {
      if (this.currentChannelData && this.currentChannelData.participants.length > 0) {
        this.currentChannelData.participants.forEach((item, i) => {
          if (item.userUuid !== this.userId) {
            db.ref('channels/' + this.currentChannel + '/unread/' + item.userUuid).push({
              uuid: item.userUuid,
              status: true
            })
          }
        })
      }
    },
    close () {
      $('.channel-section').hide()
      this.loadIsChannelWindowClosed(true)
      this.isScrollSelectedChannelToTop = false
    },
    changeType (type) {
      this.messageType = type
    }
  },
  computed: {
    ...mapState({
      'userJwt': state => state.channel.userJwt,
      'myChannels': state => state.channel.channels,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'channelUnreadCount': state => state.channel.channelUnreadCount,
      'selectedChannel': state => state.channel.selectedChannel
    }),
    canSendOtherTypes () {
      if (this.userRole !== 'Student' && this.userRole !== 'Prospective Student' && this.userRole !== 'Admitted Student') {
        return true
      }
      return false
    },
    canSend () {
      /*
      let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNEL_CAN_SEND_FEATURE_ID]
      if (channelFeature) {
        return channelFeature.enabled
      }*/
      if (this.currentChannelData.type && this.currentChannelData.type === 'broadcast' &&  (this.userRole === 'Student' || this.userRole === 'Prospective Student' || this.userRole === 'Admitted Student')) {
        return false
      }
      return true
    },
    showUrgentNotificationsTag () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNEL_SHOW_URGENT_NOTIFICATIONS_TAG]
      if (feature) {
        return feature.enabled
      }
      return true
    },
    showMessageTimestamp () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNEL_SHOW_MESSAGE_TIMESTAMP]
      if (feature) {
        return feature.enabled
      }
      return true
    }
  }

}
</script>

<style scoped>
	.collapsed > .collapsed,
	:not(.collapsed) > .expand {
	  display: none;
	}

  .channel-list {
    height: calc(100vh - 294px);
  }

  .message-in {
    width: calc(100% - 95px) !important;
  }

  .file-attachment {
    width: 0px;
    visibility: hidden;
  }

  .attachment-icon {
    transform: scaleX(-1) rotate(-45deg) scale(1.5);
    cursor: pointer;
    color: #157099;
  }

  .rich-text-editor-box {
    width: calc(100% - 75px) !important;
    left: 30px !important;
    bottom: 55px !important;
  }

  .rich-text-editor-msg {
    height: calc(100vh - 348px) !important;
  }

  .rich-text-editor-btn {
    top: 40px !important;
  }

  .rich-text-editor-send-btn {
    padding: 0px 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/channel/components/Channel.vue